import { CircularProgress, Grid, GridList, GridListTile, Paper } from '@material-ui/core'
import React, { useContext } from 'react'
import ButtonGZ from '../../../components/Button'
import Context from '../../../context'
import history from '../../../services/history'
import useStyles from './styles'

const { REACT_APP_IMAGES_URL } = process.env

function UsersImages() {
  const classes = useStyles()
  const { usersImagesList, isLoading } = useContext(Context)

  return (
    <Paper elevation={0} className={classes.usersImagesArea}>
      {isLoading ? (
        <Grid className={classes.progressArea}>
          <CircularProgress />
        </Grid>
      ) : (
        <Grid container className={classes.usersImagesTitle}>
          <Grid item xs={12} className={classes.usersImagesTitleArea}>
            <h4>IMAGENS DE USUARIOS</h4>
            <ButtonGZ
              onClick={() => {
                history.push('/images')
              }}
              style={{
                height: '36px'
              }}
            >
              Ver Mais
            </ButtonGZ>
          </Grid>

          <GridList className={classes.gridList} cols={2.5}>
            {usersImagesList &&
              usersImagesList.splice(0, 6).map(item => (
                <GridListTile key={item.id}>
                  <img src={`${REACT_APP_IMAGES_URL}${item.image}`} alt={item.id} />
                </GridListTile>
              ))}
          </GridList>
        </Grid>
      )}
    </Paper>
  )
}

export default UsersImages
